var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyRupee2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.725 18L1 11V9H4.5C5.38333 9 6.146 8.71233 6.788 8.137C7.42933 7.56233 7.81667 6.85 7.95 6H0V4H7.65C7.36667 3.41667 6.946 2.93733 6.388 2.562C5.82933 2.18733 5.2 2 4.5 2H0V0H12V2H8.75C8.98333 2.28333 9.19167 2.59167 9.375 2.925C9.55833 3.25833 9.7 3.61667 9.8 4H12V6H9.975C9.84167 7.41667 9.25833 8.604 8.225 9.562C7.19167 10.5207 5.95 11 4.5 11H3.775L10.5 18H7.725Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyRupee2);
export default __webpack_public_path__ + "static/media/currency_rupee2.fdae15b7720fbb39646f57db6206909c.svg";
export { ForwardRef as ReactComponent };